import type { AppProblemModel } from '@/services/api/AppProblemModel'
import { presentationFor } from './presentationFor'
import { retrySuffix } from './retrySuffix'

/**
 * The user-facing message for a normalized problem.
 *
 * `fallback` is the caller's own wording for the operation that failed. It
 * takes the place of the code's generic `safeDetail` for codes whose server
 * text is withheld, so a caller can say "Failed to load your orders" rather
 * than the generic phrasing.
 */
export const problemMessage = (
  problem: AppProblemModel,
  t: Parameters<typeof retrySuffix>[1],
  fallback?: string
): string => {
  const presentation = presentationFor(problem.code)
  const detail = presentation.trustServerDetail
    ? problem.detail
    : (fallback ?? presentation.safeDetail)

  return `${detail}${retrySuffix(problem, t)}`
}
